module.exports = __webpack_public_path__ + "img/sword.84fb8e90.svg";